module.exports = __webpack_public_path__ + "static/img/com_3.f35c598.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/com_3.png
// module id = pWHq
// module chunks = 0